import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { EditBlockBase } from '../../edit-block-base';
import { SessionsProvider } from '../../providers/sessions-provider';
import { Subscription } from 'rxjs';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DurationControlComponent } from "../../../common/components/duration-control/duration-control";
import { MatError, MatFormField, MatFormFieldModule } from "@angular/material/form-field";
import { TranslateModule } from "@ngx-translate/core";
import { DurationVerbosePipe } from "../../../common/pipes/duration-verbose";
import { MatInput, MatInputModule } from "@angular/material/input";
import { NgIf } from "@angular/common";

@Component({
  selector: 'session-exercice-repeat-edit',
  providers: [],
  styleUrls: ['./../component-edit.scss'],
  standalone: true,
  imports: [
    DurationControlComponent,
    MatFormFieldModule,
    MatError,
    DurationVerbosePipe,
    TranslateModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    NgIf
  ],
  templateUrl: './session-exercice-repeat-edit.html'
})
export class SessionExerciceRepeatEditComponent extends EditBlockBase implements OnInit, AfterViewInit, OnDestroy {

    private subscriptions: Subscription[] = [];
    public serieMinValue = 1;
    public repeatMinValue = 1;
    public nbSerieFormControl: FormControl = new FormControl('1', [
        Validators.required,
        Validators.min(1)
    ]);
    public nbRepeatFormControl: FormControl = new FormControl('1', [
        Validators.required,
        Validators.min(1)
    ]);

    constructor(
        public sessionsProvider: SessionsProvider
    ) {
        super();
    }

    ngOnInit(): void {
        this.nbSerieFormControl.setValue(this.data.data.sessionItemExercice.nbSerie);
        this.nbRepeatFormControl.setValue(this.data.data.sessionItemExercice.nbRepeat);
    }

    ngAfterViewInit(): void {
        this.subscriptions.push(
            this.nbSerieFormControl.valueChanges.subscribe((value: number) => {
                this.nbSerieFormControl.markAsTouched();
                if (value < 1) {
                    this.baseComponent.onValuesAreNotGood.emit();
                }else{
                    this.baseComponent.onValuesAreGood.emit();
                }
                this.data.data.sessionItemExercice.nbSerie = value;

                this.baseComponent.calcTotalPayload();
                this.baseComponent.calcTotalTime();
                this.baseComponent.onTimeBasedInfoUpdated.emit();
                this.baseComponent.onChanged.emit();
            })
        );
        this.subscriptions.push(
            this.nbRepeatFormControl.valueChanges.subscribe((value: number) => {
                this.nbRepeatFormControl.markAsTouched();
                if (value < 1) {
                    this.baseComponent.onValuesAreNotGood.emit();
                }else{
                    this.baseComponent.onValuesAreGood.emit();
                }
                this.data.data.sessionItemExercice.nbRepeat = value;

                this.baseComponent.calcTotalPayload();
                this.baseComponent.calcTotalTime();
                this.baseComponent.onTimeBasedInfoUpdated.emit();
                this.baseComponent.onChanged.emit();
            })
        );
    }

    public calcTotalPayload() {
        this.baseComponent._totalPayload =
            this.data.data.sessionItemExercice.payload  *
            this.data.data.sessionItemExercice.nbRepeat *
            this.data.data.sessionItemExercice.nbSerie;
    }

    public onDurationChange(): void {
        this.baseComponent.calcTotalTime();
        this.baseComponent.onTimeBasedInfoUpdated.emit();
        this.baseComponent.onChanged.emit();
    }

    public onRestTimeChange(): void {
        this.baseComponent.calcTotalTime();
        this.baseComponent.onTimeBasedInfoUpdated.emit();
        this.baseComponent.onChanged.emit();
    }

    public onCommentChange(): void {
        this.baseComponent.onChanged.emit();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
